import * as types from '../mutation-types'

const state = {
	activeUser: {}
}

export const getters = {
	activeUser: state => state.activeUser,
	activeUserName: state => state.activeUser.name
}

export const actions = {
	setActiveUser ({ commit }, user) {
		commit(types.SET_ACTIVE_USER, {
			user
		})
	},
	updateActiveUserName ({ commit }, name) {
		commit(types.UPDATE_ACTIVE_USER_NAME, {
			name
		})
	}
}

export const mutations = {
	[types.SET_ACTIVE_USER] (state, payload) {
		state.activeUser = payload.user
	},
	[types.UPDATE_ACTIVE_USER_NAME] (state, payload) {
		state.activeUser.name = payload.name
	},
	[types.CLEAR_USER_VARIABLES] (state, payload) {
		state.activeUser = {}
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js